var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 847,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 848,
	"./assets/thewest-digital-hero-variation-a.jpg": 2882,
	"./assets/thewest-digital-hero-variation-afl50-mobile.jpg": 849,
	"./assets/thewest-digital-hero-variation-afl50.jpg": 2883,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 850,
	"./assets/thewest-digital-hero-variation-b.jpg": 2884,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 851,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2885,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 852,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 2886,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 853,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2887,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 854,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2888,
	"./assets/thewest-digital-hero.jpg": 2889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 846;